import { Address } from '@pelicargo/types';
import { formatAddress, isSameDeliveryAddress } from '@pelicargo/utils';

import { MatchTag } from './MatchTag';

type Props = {
  label: string;
  printedAddress: string | null;
  quoteAddress: Address | null;
};

/**
 * The delivery address the email printed, checked against the quote's. Null (no tag) when the comparison is undecided —
 * either side missing, or neither carrying a zip to compare on.
 */
export const AddressMatchTag = ({ label, printedAddress, quoteAddress }: Props) => {
  if (!quoteAddress) return null;

  const isMatch = isSameDeliveryAddress(printedAddress, quoteAddress);
  if (isMatch === null) return null;

  const help = isMatch
    ? 'Matches the delivery address on the quote'
    : `Does not match — the quote holds ${formatAddress(quoteAddress)}`;
  return <MatchTag isMatch={isMatch} help={help} label={label} />;
};
